import { SubscriptionCodeStatus } from '../../../enums/subscription-code-status'
import { getTheme } from '../../../theme/index'

const theme = getTheme()

export const statusMap : {[K in SubscriptionCodeStatus]?: {color: string}} = {
  [SubscriptionCodeStatus.available]: { color: theme.colors.primary },
  [SubscriptionCodeStatus.expired]: { color: theme.colors.redDark },
  [SubscriptionCodeStatus.used]: { color: theme.colors.redDark },
  [SubscriptionCodeStatus.pendingConfirmation]: { color: theme.colors.yellowDark }
}
